import React from 'react'
import { Helmet } from 'react-helmet-async'
import { UsageAnalyticsLayout } from '../../layouts/Analytics'
import type { AnalyticsAPIResponse } from '../../interfaces'

interface Props {
  dateRange: {
    startDate: Date
    endDate: Date
  }
  data: AnalyticsAPIResponse | null
  showBandwidth: Boolean
}

const UsageAnalyticsPage = ({
  dateRange,
  data,
  showBandwidth,
}: Props): React.ReactElement => (
  <React.Fragment>
    <Helmet>
      <title>Usage Analytics</title>
      <meta name="description" content="Usage Analytics page" />
    </Helmet>
    <UsageAnalyticsLayout {...{ dateRange, data, showBandwidth }} />
  </React.Fragment>
)

export default UsageAnalyticsPage
